import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const PhotoPreviewCard = ({ 
  file, 
  onRemove, 
  index 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.2 }}
      className="relative aspect-square rounded-2xl overflow-hidden shadow-md group"
    >
      {/* Image Preview */}
      <Image
        src={file?.preview}
        alt={file?.alt || `Uploaded photo ${index + 1} showing ${file?.name}`}
        className="w-full h-full object-cover"
      />
      {/* Remove Button - Top Right with X */}
      <motion.button
        whileTap={{ scale: 0.9 }}
        onClick={onRemove}
        className="absolute top-2 right-2 w-8 h-8 rounded-full bg-gray-800/80 backdrop-blur-sm flex items-center justify-center hover:bg-gray-900 transition-all z-10"
        aria-label={`Remove ${file?.name}`}
      >
        <Icon name="X" size={16} className="text-white" />
      </motion.button>
      {/* Ready Badge - Bottom Left */}
      {file?.valid && (
        <div className="absolute bottom-2 left-2 px-3 py-1 rounded-full bg-cyan-400 backdrop-blur-sm flex items-center gap-1.5 shadow-md">
          <span className="text-xs font-bold text-white">Ready</span>
        </div>
      )}
      {/* Error Badge - Bottom Left */}
      {file?.error && (
        <div className="absolute bottom-2 left-2 px-3 py-1 rounded-full bg-red-500 backdrop-blur-sm flex items-center gap-1.5 shadow-md">
          <Icon name="AlertCircle" size={12} className="text-white" />
          <span className="text-xs font-bold text-white">Error</span>
        </div>
      )}
    </motion.div>
  );
};

export default PhotoPreviewCard;